import React, { useEffect, useState } from 'react';
import { Card, Form, Row } from 'react-bootstrap';

import { useContextInfo } from '../../context/ContextInfo';
import { useGetDta } from '../../hooks/useGetDta';
import { fetchConToken } from '../../api/fetch';
import LoadinSpin from '../ui/LoadinSpin';
import { useCheck } from '../../hooks/useCheck';
const opPort = [
    { name: 'comprobantes', label: "Mostrar 'Mis comprobantes'" },
    { name: 'soporte', label: "Mostrar 'Soporte técnico'" },
    { name: 'docs', label: "Mostrar 'Mis documentos'" },
    { name: 'traficnow', label: "Mostrar 'Tráfico actual'" },
    { name: 'banner', label: "Mostrar 'Banner de Publicidad'" },
    { name: 'password', label: 'Permitir cambiar contraseña' },
    { name: 'trafic', label: 'Mostrar estadísticas de tráfico' },
    { name: 'lugares', label: "Mostrar 'Menu personalizado'" },
    { name: 'recargas', label: 'Mostrar  telefonía móvil (Recargas)' },
];
const optionsPort = {
    comprobantes: true,
    soporte: true,
    docs: true,
    traficnow: true,
    banner: true,
    password: true,
    trafic: true,
    lugares: true,
    recagas: true,
};
const ShowPortal = () => {
    const { setResp } = useContextInfo();

    const { loading, data } = useGetDta('main/portal/oppport');
    const [id, setId] = useState('');
    const [check, handleCkeckChange, setFormCheck] = useCheck({
        ...optionsPort,
    });
    useEffect(() => {
        setFormCheck({ ...check, ...data });
        setId(data?.id);
    }, [data]);
    const onSubmit = async (e) => {
        e.preventDefault();
        let res = await fetchConToken(`main/portal`, { id, items: { ...check } }, 'POST');
        setResp(res);
    };

    if (loading) return <LoadinSpin />;
    return (
        <div>
            <Card>
                <Card.Header>Opciones disponibles</Card.Header>
                <Card.Body>
                    <Form onSubmit={onSubmit}>
                        <div className="p-4">
                            {opPort.map((ck, i) => (
                                <Row key={i}>
                                    <Form.Check
                                        type="switch"
                                        name={ck.name}
                                        id="custom-switch"
                                        label={ck.label}
                                        checked={check[`${ck.name}`]}
                                        onChange={handleCkeckChange}
                                    />
                                </Row>
                            ))}
                        </div>
                        <button type="submit" className="btn btn-primary">
                            Guardar
                        </button>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

export default ShowPortal;
